export const facebookAppId = '124049958259951';
export const facebookTestAppId = '787166853341820';
// export const appleId = 'au.com.autech.whatsonin';
export const appleId = 'au.com.whatsonin';
export const googleClientId = '772171638878-cv25r0sh01urkv3ako7rne3e59us0gd9.apps.googleusercontent.com';